export const GET_PRICEOM_CONFIG_REQUEST = 'GET_PRICEOM_CONFIG_REQUEST';
export const GET_PRICEOM_CONFIG_REQUEST_SUCCESS = 'GET_PRICEOM_CONFIG_REQUEST_SUCCESS';
export const GET_PRICEOM_CONFIG_REQUEST_FAILURE = 'GET_PRICEOM_CONFIG_REQUEST_FAILURE';

export const CHANGE_PRICEOM_CONFIG_REQUEST = 'CHANGE_PRICEOM_CONFIG_REQUEST';
export const CHANGE_PRICEOM_CONFIG_REQUEST_SUCCESS = 'CHANGE_PRICEOM_CONFIG_REQUEST_SUCCESS';
export const CHANGE_PRICEOM_CONFIG_REQUEST_FAILURE = 'CHANGE_PRICEOM_CONFIG_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/redux/constants/priceom_config.constants.js